/** biome-ignore-all lint/suspicious/noExplicitAny: <explanation> */
import clsx from 'clsx'
import type { PropsWithChildren } from 'react'
import { type Control, Controller } from 'react-hook-form'
import { Show } from '@/components/show'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select'
import { cn } from '@/lib/utils'

interface selectOption {
  label: string
  id: any
}

export interface ReviewCardProps extends PropsWithChildren {
  title?: string
  subTitle?: string
  withSelect?: boolean
  disabledSelect?: boolean
  selectLabel?: string
  headerCard?: boolean
  bodyClass?: string
  titleClassName?: string
  selectControl?: Control<any>
  selectField?: string
  selectOptions?: selectOption[]
  onSelectChange?: (value: string) => void
}

export const ReviewCard = ({
  title,
  subTitle,
  children,
  withSelect,
  disabledSelect,
  selectLabel,
  headerCard = true,
  bodyClass,
  titleClassName,
  selectControl,
  selectField = '',
  selectOptions = [],
  onSelectChange
}: ReviewCardProps) => {
  return (
    <div className="w-full rounded-lg shadow-sm border border-ring/50 text-base">
      <Show when={headerCard}>
        <div className="w-full bg-[var(--brand-blue-4)]/20 px-6 font-bold py-2 flex rounded-t-lg">
          <div className="w-full">
            <div className={cn('text-[var(--brand-slate-1)]', titleClassName)}>
              {title}
            </div>
            <Show when={subTitle !== undefined}>
              <div className="text-2xl text-[var(--brand-blue-2)] mt-3">
                {subTitle}
              </div>
            </Show>
          </div>
          <Show when={withSelect || false}>
            <div>
              <p
                className={clsx(
                  'text-base mb-2',
                  { 'text-muted-foreground/70': disabledSelect },
                  { 'text-[var(--brand-slate-1)]': !disabledSelect }
                )}
              >
                {selectLabel}
              </p>
              <Controller
                control={selectControl}
                name={selectField}
                render={({ field }) => (
                  <Select
                    onValueChange={(value: string) => {
                      onSelectChange?.(value)
                      field.onChange(value)
                    }}
                    value={field.value}
                    disabled={disabledSelect || false}
                  >
                    <SelectTrigger className="w-64 bg-background">
                      <SelectValue placeholder="Selecione" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectGroup>
                        {selectOptions.map((option) => (
                          <SelectItem key={option.id} value={option.label}>
                            {option.label}
                          </SelectItem>
                        ))}
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                )}
              />
            </div>
          </Show>
        </div>
      </Show>
      <div
        className={cn(
          'w-full rounded-b-lg bg-muted',
          { 'rounded-t-lg': !headerCard },
          bodyClass
        )}
      >
        {children}
      </div>
    </div>
  )
}
